"use client";

import { create } from "zustand";

type PostingFilter = "ALL" | "OPEN" | "CLOSED" | "EXPIRED" | "CANCELLED";

type UiState = {
  postingFilter: PostingFilter;
  setPostingFilter: (f: PostingFilter) => void;
};

export const useUiStore = create<UiState>((set) => ({
  postingFilter: "OPEN",
  setPostingFilter: (postingFilter) => set({ postingFilter }),
}));
